import React from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItem, TextField } from '@material-ui/core';

import RequestField from '../request-field';

/**
 * Text, textarea or select input bound to the `{ value, error }` form state
 * shape used across the app.
 */
const RequestInput = (props) => {
  const {
    field,
    formData,
    setFormData,
    tLabel,
    required,
    tHelper,
    tError,
    tPlaceholder,
    options,
    onValueChange,
    ...textFieldProps
  } = props;
  const { t } = useTranslation();

  const hasError = Boolean(formData[field]?.error);

  const handleChange = (event) => {
    const { value } = event.target;

    setFormData({ ...formData, [field]: { value, error: false } });

    if (onValueChange) {
      onValueChange(value);
    }
  };

  return (
    <RequestField
      tLabel={tLabel}
      required={required}
      tHelper={tHelper}
      tError={tError}
      hasError={hasError}
    >
      <TextField
        variant="outlined"
        className="request-field-control"
        select={Boolean(options)}
        value={formData[field]?.value ?? ''}
        error={hasError}
        onChange={handleChange}
        placeholder={tPlaceholder ? t(tPlaceholder) : undefined}
        {...textFieldProps}
      >
        {options &&
          options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {t(option.tLabel)}
            </MenuItem>
          ))}
      </TextField>
    </RequestField>
  );
};

export default RequestInput;
